import { useContext } from "react";
import { BrowserRouter, Navigate, Routes, Route } from "react-router-dom";
import Dashboard from "./pages/Dashboard";
import Products from "./pages/Products";
import '../src/styles/Main.css';
import NavBar from "./components/NavBar";
import { UserState } from "./context/UserState";
import Users from "./pages/Users";
import Production from "./pages/Production";
import UserContext from "./context/UserContext";
import { hasRoleAccess } from "./constants/business";
import Sales from "./pages/Sales";
import Delivery from "./pages/Delivery";
import Administrator from "./pages/Administrator";

function RoleRoute({ tab, children }) {
  const { user } = useContext(UserContext);
  return user && hasRoleAccess(user.rol, tab) ? children : <Navigate to="/" replace />;
}

export default function App() {
  return (
    <div>
      <BrowserRouter>
        <UserState>
          <NavBar />
          <Routes>
            <Route path="/" element={<Dashboard />} />
            <Route path="/products" element={<RoleRoute tab="catalog"><Products /></RoleRoute>} />
            <Route path="/production" element={<RoleRoute tab="production"><Production /></RoleRoute>} />
            <Route path="/sales" element={<RoleRoute tab="sales"><Sales /></RoleRoute>} />
            <Route path="/delivery" element={<RoleRoute tab="delivery"><Delivery /></RoleRoute>} />
            <Route path="/users" element={<RoleRoute tab="users"><Users /></RoleRoute>} />
            <Route path="/administrator" element={<RoleRoute tab="admin"><Administrator /></RoleRoute>} />
          </Routes>
        </UserState>
      </BrowserRouter>
    </div>
  );
}
